import { z } from "zod";

export const LoanTargetsEnum = {
  INVEST_IN_PLATFORM: "INVEST_IN_PLATFORM",
  WITHDRAWAL: "WITHDRAWAL",
} as const;

export const loanTargetsSchema = z.enum([
  LoanTargetsEnum.INVEST_IN_PLATFORM,
  LoanTargetsEnum.WITHDRAWAL,
]);

export type LoanTargets = z.infer<typeof loanTargetsSchema>;